function rgbToHsl(redValue, greenValue, blueValue) {
	let normalizedRed = redValue / 255;
	let normalizedGreen = greenValue / 255;
	let normalizedBlue = blueValue / 255;

	let maximumComponent = Math.max(normalizedRed, normalizedGreen, normalizedBlue);
	let minimumComponent = Math.min(normalizedRed, normalizedGreen, normalizedBlue);
	let deltaComponent = maximumComponent - minimumComponent;

	let lightnessValue = (maximumComponent + minimumComponent) / 2;
	let hueValue = 0;
	let saturationValue = 0;

	if (deltaComponent !== 0) {
		saturationValue = deltaComponent / (1 - Math.abs(2 * lightnessValue - 1));

		switch (maximumComponent) {
			case normalizedRed:
				hueValue = ((normalizedGreen - normalizedBlue) / deltaComponent) % 6;
				break;
			case normalizedGreen:
				hueValue = (normalizedBlue - normalizedRed) / deltaComponent + 2;
				break;
			case normalizedBlue:
				hueValue = (normalizedRed - normalizedGreen) / deltaComponent + 4;
				break;
		}

		hueValue *= 60;
		if (hueValue < 0) hueValue += 360;
	}

	return {
		hue: hueValue,                    // 0–360
		saturation: saturationValue,      // 0–1
		lightness: lightnessValue         // 0–1
	};
}

function hslToRgb(hueValue, saturationValue, lightnessValue) {
	let chromaValue = (1 - Math.abs(2 * lightnessValue - 1)) * saturationValue;
	let intermediateValue = chromaValue * (1 - Math.abs((hueValue / 60) % 2 - 1));
	let matchValue = lightnessValue - chromaValue / 2;

	let redPrime = 0;
	let greenPrime = 0;
	let bluePrime = 0;

	if (hueValue >= 0 && hueValue < 60) {
		redPrime = chromaValue;
		greenPrime = intermediateValue;
		bluePrime = 0;
	} else if (hueValue < 120) {
		redPrime = intermediateValue;
		greenPrime = chromaValue;
		bluePrime = 0;
	} else if (hueValue < 180) {
		redPrime = 0;
		greenPrime = chromaValue;
		bluePrime = intermediateValue;
	} else if (hueValue < 240) {
		redPrime = 0;
		greenPrime = intermediateValue;
		bluePrime = chromaValue;
	} else if (hueValue < 300) {
		redPrime = intermediateValue;
		greenPrime = 0;
		bluePrime = chromaValue;
	} else {
		redPrime = chromaValue;
		greenPrime = 0;
		bluePrime = intermediateValue;
	}

	return {
		red: Math.round((redPrime + matchValue) * 255),
		green: Math.round((greenPrime + matchValue) * 255),
		blue: Math.round((bluePrime + matchValue) * 255)
	};
}

export function hslToRgbString(hslstring) {

	const
		[hue, saturation, lightness] = hslstring.split(":"),
		hueValue = parseFloat(hue),
		saturationValue = parseFloat(saturation),
		lightnessValue = parseFloat(lightness),
		rgbObject = hslToRgb(hueValue, saturationValue, lightnessValue);
	const
		redHex = rgbObject.red.toString(16).padStart(2, "0"),
		greenHex = rgbObject.green.toString(16).padStart(2, "0"),
		blueHex = rgbObject.blue.toString(16).padStart(2, "0");

	return `${redHex}${greenHex}${blueHex}`.toUpperCase();
}

export function rgbToHslString(rgbstring) {

	const
		redHex = rgbstring.substring(0, 2),
		greenHex = rgbstring.substring(2, 4),
		blueHex = rgbstring.substring(4, 6),

		redValue = parseInt(redHex, 16),
		greenValue = parseInt(greenHex, 16),
		blueValue = parseInt(blueHex, 16),

		hslObject = rgbToHsl(redValue, greenValue, blueValue);

	return `${hslObject.hue}:${hslObject.saturation}:${hslObject.lightness}`.toUpperCase();

}


